import { ConfigConstants } from '../../config/config-constants';
import { LoadStatus } from '../load-status';

/**
 * Feature key under which the input-field-properties slice is registered in the root store.
 */
export const INPUT_FIELD_PROPERTIES_FEATURE_KEY = 'inputFieldProperties';

/**
 * Naked, serializable shape of an input field property — the data fields of
 * {@link InputFieldPropertyModel} without the class.
 */
export type InputFieldPropertyState = Readonly<{
    screenName: string;
    fieldName: string;
    fieldValue: string;
    screenPos: number;
    fieldPos: number;
    scannable: boolean;
    mandatory: boolean;
    readonly: boolean;
    minLength: number;
    maxLength: number;
    minValue: number;
    maxValue: number;
    pattern: string;
    patternScan: string;
    valueHelperID: string;
    process?: ConfigConstants.PROCESS_INDICATOR;
    defaultValue?: string;
}>;

/**
 * Input-field-properties reference data loaded once from OData (re-loaded on sync). This is a
 * bulk-replace collection — there is no per-entity creation and no expiry, so it carries only
 * the list and the load status (see {@link LoadStatus}).
 */
export type InputFieldPropertiesCollectionState = Readonly<{
    properties: InputFieldPropertyState[];
    status: LoadStatus;
}>;

export const initialInputFieldPropertiesCollectionState: InputFieldPropertiesCollectionState = {
    properties: [],
    status: LoadStatus.Idle,
};
